// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel } from '../project-navigation.model';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { UserSettings } from '@user/model/user-settings';
import { ProjectComponentPresenter } from '@project/components/project-component.presenter';

@Component({
  standalone: false,
  templateUrl: './compare-list.component.html',
  selector: 'app-compare-list'
})
export class CompareListComponent implements OnDestroy, OnInit {
  @Output() public finish = new EventEmitter<void>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  public constructor(
    private projectNavigationService: ProjectNavigationService,
    private userSettings: UserSettings,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) {}

  public ngOnDestroy() {}

  public ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.currentModel = {
      importType: null,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      visibleSharedProjects: true,
      visibleHiddenProjects: true
    };

    this.projectNavigationService.openPreselectedProjectGroup(this.model);
  }

  public updateSubmitEnabled() {
    this.submitEnabled = this.model.currentSelectedItem && this.model.currentSelectedItem instanceof ProjectHeadVO;
  }

  public compareItemList(): Promise<boolean> {
    this.finish.emit();
    const projectToCompare: ProjectHeadVO =
      this.model.currentSelectedItem && this.model.currentSelectedItem instanceof ProjectHeadVO
        ? this.model.currentSelectedItem
        : (this.model.currentSelectedItem as ProjectGroupVO).projects[0];
    return this.projectComponentPresenter.openProjectVersionHistoryComponent(projectToCompare, true);
  }

  public cancel() {
    this.finish.emit();
  }
}
